import { authStorage, encrypt, errorLogger, getCookie, setCookie } from '@ajaibid/utils';
import { AES_ENCRYPTION_SECRET_KEY, COOKIE_KEY, COOKIE_SECURE } from '@config/constanta';
import { v7RefreshPinToken } from '@/services/api/auth/refreshPinToken';
import { markSoftLoginPin } from '@helpers/pinEntryPoint';
import clearSession from './clearSession';

function isPinConfirmed() {
  // Same as !isFirstLoad
  return getCookie(COOKIE_KEY.isFirstLoad) !== '1';
}

/**
 * Set pin tokens received to cookie
 * @param {import('@services/api/auth/refreshPinToken').v7RefreshPinToken} data
 */
function setTokens(data) {
  setCookie(COOKIE_KEY.pin_refresh, data.pin_refresh, COOKIE_SECURE);
  setCookie(COOKIE_KEY.pin_token, data.pin_token, COOKIE_SECURE);

  if (isPinConfirmed() && data.pin_token) {
    const ciphertext = encrypt(data.pin_token, AES_ENCRYPTION_SECRET_KEY);
    authStorage.set('xyz', ciphertext);
  }
}

async function waitPendingFetch() {
  return new Promise((resolve) => {
    const intervalCheck = () => {
      if (window.pendingFetch <= 0) {
        window.pendingFetch = 0;
        resolve();
      } else {
        setTimeout(intervalCheck, 100);
      }
    };
    intervalCheck();
  });
}

export async function refreshPinTokenFn() {
  await waitPendingFetch();
  const data = await v7RefreshPinToken()
    .then((result) => {
      if (result?.status === 401 || result?.status === 400 || result?.status === '400') {
        clearSession(false);
        // Redirect to PIN page instead of logout when session expires
        markSoftLoginPin();
        window.location.href = '/pin';
      }
      if (!result) {
        throw new Error('Empty result');
      }

      return result;
    })
    .catch((err) => {
      errorLogger('ERROR_API', err.message, {
        path: err.config.url,
        'X-Ht-Ver-Id': !!err.config.headers['X-Ht-Ver-Id'],
      });

      if (err.code) {
        clearSession();
      }
    });

  setTokens(data);

  // Add delay to ensure the changes before other pending fetch executed
  return new Promise((resolve) => {
    setTimeout(() => {
      window.pinRefreshToken = null;
      resolve();
    }, 500);
  });
}
